import React from 'react'
import { TypeAlignmentFields, TypeHorizontalAlignment, TypeVerticalAlignment } from '../lib/types/alignment'

interface AlignmentContextValue {
  horizontal: TypeHorizontalAlignment
  vertical: TypeVerticalAlignment
}

export const DefaultAlignment: TypeAlignmentFields = {
  horizontal: 'default',
  vertical: 'default',
}

export const AlignmentContext = React.createContext<AlignmentContextValue>(DefaultAlignment)
